<template>
    <EntrancePageLayout>
        <form @submit.prevent="requestResetPassword(password)" class="container" novalidate>
            <div class="reset-pass-row">
                <span class="password-img">
                    <img src="@/assets/gifs/password.gif"
                         alt="password"
                         width="80"
                         height="85"
                    >
                </span>
            </div>
            <span class="titleMedium">Reset password</span>
            <div class="inputs-container">
                <FormInput v-model="password"
                           id="password"
                           placeholder="New password"
                           inputType="password"
                           :is-disabled="loading"
                           :maxLength="20"
                           :showValidationErrors="showValidationErrors"
                           @changedValue="inputValueChange($event, 'password')"
                           :triggerCustomValidationOnChange="password"
                           :isPassHidden="isPassHidden"
                           @showPasswordChanged="showPasswordChanged"
                           :customValidations="[
                               { validationFunc: passwordRegexFunction, errorMsg: passwordValidationErr}
                           ]"
                           :isRequired="true">
                </FormInput>
                <FormInput v-model="confirmPassword"
                           class="confirmPassword"
                           id="confirmPassword"
                           placeholder="Confirm new password"
                           inputType="password"
                           :is-disabled="loading"
                           :maxLength="20"
                           :showValidationErrors="showValidationErrors"
                           @changedValue="inputValueChange($event, 'confirmPassword')"
                           :customValidations="[
                               { validationFunc: passwordsMatch, errorMsg: passwordsMatchErr },
                               { validationFunc: passwordRegexFunction, errorMsg: passwordValidationErr}
                           ]"
                           :triggerCustomValidationOnChange="confirmPassword"
                           :isPassHidden="isPassHidden"
                           @showPasswordChanged="showPasswordChanged"
                           :isRequired="true">
                </FormInput>
            </div>
            <div class="reset-pass-row footer">
                <Button id="reset-password-button" type="submit" :loading="loading">Save password</Button>
            </div>
        </form>
    </EntrancePageLayout>
</template>
<script>
import FormInput from 'components/inputs/formInput/FormInput.vue';
import Button from 'components/button/Button.vue';
import { passwordRegexFunction } from 'services/utils/regex';
import http from 'services/utils/http';
import EntrancePageLayout from '@/pages/entrance/components/EntrancePageLayout.vue';
import { PASSWORD_MATCH_ERROR, PASSWORD_VALIDATION_ERROR } from 'services/metaData/errors';

export default {
    name: 'RequestResetPasswordPage',
    components: {
        EntrancePageLayout,
        FormInput,
        Button
    },
    data() {
        return {
            password: '',
            confirmPassword: '',
            showValidationErrors: false,
            isPassHidden: true,
            passwordValid: {
                password: false,
                confirmPassword: false
            },
            loading: false,
            passwordRegexFunction,
            passwordValidationErr: PASSWORD_VALIDATION_ERROR,
            passwordsMatchErr: PASSWORD_MATCH_ERROR
        };
    },
    computed: {
        token() {
            return this.$route.query.token;
        }
    },
    methods: {
        inputValueChange({ isValid, value }, key) {
            if (['password', 'confirmPassword'].includes(key)) {
                this.passwordValid[key] = isValid;
                if (value === this[key]) return;
                this.showValidationErrors = false;
            }
        },
        passwordsMatch(passConfirm) {
            return passConfirm === this.password;
        },
        showPasswordChanged(value) {
            this.isPassHidden = value;
        },
        async resetPassword({ token, password }) {
            const apiUrl = '/partners/auth/reset';
            return http.post(apiUrl, { token, password }, false);
        },
        async requestResetPassword(password) {
            if (!this.passwordValid.confirmPassword || !this.passwordValid.password) {
                this.showValidationErrors = true;
                return;
            }
            this.loading = true;
            try {
                await this.resetPassword({
                    password,
                    token: encodeURIComponent(this.token)
                });
                await this.$router.replace({
                    name: 'login',
                    query: { reset: true }
                });
            } catch (error) {
                await this.$router.replace({
                    name: 'forgot',
                    query: { invalidToken: true }
                });
            }
            this.loading = false;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "~styles/styleGuide.V2.scss";
@import "~styles/buttons.V2.scss";

.container {
    display: flex;
    position: relative;
    flex-direction: column;
    padding: $spacing-xxl-6;
}

.messageWrap.bodyStrong.error-message.type-error {
    margin: $spacing-xl 0 0;
}

.reset-pass-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.footer {
    align-items: center;
    justify-content: flex-end;
}

.titleMedium {
    line-height: normal;
    color: $dark-500;
    margin-top: $spacing-xl;
}

.inputs-container {
    margin-top: $spacing-xl;
    margin-bottom: $spacing-xxl-6;
}

.confirmPassword {
    margin-top: $spacing-xl;
}

::v-deep .ssa-button.primary {
    width: 151px;
    display: flex;
    justify-content: center;
    align-items: center;

    .loader-icon {
        display: inline-flex;
    }
}

.password-img {
    transform: translateX(-10px);
}
</style>
